// Importar imágenes locales para el carrusel del hero
export const heroImages = [
  {
    id: 1,
    url: "/assets/image1.webp",
    alt: "Diseño interior moderno"
  },
  {
    id: 2,
    url: "/assets/image2.webp",
    alt: "Arquitectura contemporánea"
  },
  {
    id: 3,
    url: "/assets/image3.webp",
    alt: "Espacio minimalista"
  },
  {
    id: 4,
    url: "/assets/image4.webp",
    alt: "Diseño de interiores elegante"
  },
  {
    id: 5,
    url: "/assets/image5.webp",
    alt: "Villa moderna"
  }
];
